import React from "react";

const DobInput = ({ value, onChange, invalid = false, label = "DOB" }) => {
  return (
    <div className="flex items-center space-x-2">
      <label
        htmlFor="dob"
        className="block text-base font-medium text-black w-full md:w-1/4"
      >
        {label} *
      </label>

      <input
        type="text"
        id="dob"
        placeholder="MM/DD/YYYY"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`text-black mt-1 block w-full px-3 py-2 bg-slate-50 border-0 border-b-2 ${
          invalid ? "border-b-red-500" : "border-b-gray-300"
        } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500`}
      />
    </div>
  );
};

export default DobInput;
